import { makeAutoObservable, runInAction } from 'mobx'

export class ConnectivityStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })

    this.init()
  }

  public isOnline: boolean = true

  public isShowMessage: boolean = false

  private timeoutID: ReturnType<typeof setTimeout> | undefined

  private init() {
    if (window?.navigator?.onLine) {
      this.setOnline()
    } else {
      this.setOffline()
      this.isShowMessage = true
    }

    this.observeInternetConnection()
  }

  private observeInternetConnection() {
    window.addEventListener('online', this.setIsOnline.bind(this, true))
    window.addEventListener('offline', this.setIsOnline.bind(this, false))
  }

  private setIsOnline(isOnline: boolean) {
    if (isOnline) {
      this.setOnline()
      this.showMessage()
    } else {
      this.setOffline()
      this.hideMessage()
    }
  }

  private setOnline() {
    runInAction(() => {
      this.isOnline = true
    })
  }

  private setOffline() {
    runInAction(() => {
      this.isOnline = false
    })
  }

  private showMessage() {
    this.timeoutID = setTimeout(() => {
      runInAction(() => {
        this.isShowMessage = false
      })
    }, 2000)
  }

  private hideMessage() {
    clearTimeout(this.timeoutID)
    runInAction(() => {
      this.isShowMessage = true
    })
  }
}

export const connectivityStore = new ConnectivityStore()
